import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import 'app/Window'

import { createRoot } from 'react-dom/client'

import { App } from './App'

const appNode = document.getElementById('app')

// @ts-expect-error TS(2345) FIXME: Argument of type 'HTMLElement | null' is not assig... Remove this comment to see the full error message
const root = createRoot(appNode)
root.render(<App />)

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept('./App', () => {
    root.render(<App />)
  })
}
